import { PRIMARY_BUTTON } from "@/constants";
import clsx from "clsx";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setShiftDetails } from "@/app_redux/reducers/slices/auth/rota_slice";
import { useNavigate } from "react-router";

const ManufacturerHeaderSection = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handelAddNavigate = () => {
    navigate(`/app/inventory/manufacture-add`);
    dispatch(setShiftDetails({ data: null }));
  };

  return (
    <div className="p-3 w-full rounded-md bg-white flex flex-row items-center justify-between gap-3">
      <h3 className="text-sm sm:text-base font-semibold whitespace-nowrap">Listed Manufacturers</h3>
      <button type="button" className={clsx(PRIMARY_BUTTON, "shrink-0")} onClick={() => handelAddNavigate()}>
        + Add Manufacturer
      </button>
    </div>
  );
};
export default ManufacturerHeaderSection;
